import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Users, DollarSign, Video, ShoppingBag, BookOpen, Check, X, Upload, TrendingUp, Crown, Lock, Unlock, Settings, RefreshCw, Globe, Edit3, FileSpreadsheet, AlertCircle, Download, Youtube, Plus, Layers, Calendar, Flag, Star, Trash2, Gift, Ban, UserX, UserCheck, CheckCircle, ShieldCheck, Clock, PartyPopper, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Founder Approvals tab.
 *
 * Lifted out of AdminPanel.js during the Phase 2 frontend split (Wave 4).
 * Pure presentational — receives parent state + handlers via props.
 */
export default function FounderApprovalsTab(props) {
  const { user, navigate, getAuthHeader, fetchAllData, fileInputRef, users, setUsers, userSearch, setUserSearch, filteredUsers, pendingFounders, founderSettings, setFounderSettings, founderSeatsRemaining, updateFounderSettings, toggleFounderEnrollment, toggleFoundingMember, suspendUser, archiveUser, permanentlyDeleteUser, changeUserTier, sales, pendingSales, pendingListingSales, handleVerifySale, handleVerifyListingSale, handleUnverifyListingSale, handleCancelListingSale, commissionDashboard, promoCodes, newPromo, setNewPromo, createPromoCode, deletePromoCode, promoToDelete, setPromoToDelete, potData, setPotData, updatePot, advertisers, pendingVideos, pendingLibraryVideos, handleBatchApproveVideos, handleVideoReview, handleLibraryVideoReview, moveDownlineData, setMoveDownlineData, featuredMembers, selectedUserToFeature, setSelectedUserToFeature, featuredText, setFeaturedText, handleAddFeaturedMember, handleRemoveFeaturedMember, tierFeatures, editingTier, setEditingTier, editFeatures, setEditFeatures, startEditingTier, saveTierFeatures, customTiers, showTierForm, setShowTierForm, newTier, setNewTier, tierFeaturesInput, setTierFeaturesInput, handleCreateTier, handleDeleteTier, pendingServices, flaggedServices, handleApproveService, handleFlagService, handleDeleteService, edirectoryStatus, syncingEdir, syncEdirectory, importedTransactions, importing, importResult, handleFileSelect, downloadSampleCSV } = props;

  return (
    <div className="space-y-4" data-testid="approvals-tab">
      <h2 className="text-2xl font-playfair font-bold text-foreground mb-4">Pending Founder Approvals</h2>
                  {pendingFounders.length === 0 ? (
                    <div className="wm-card p-8 rounded-lg text-center">
                      <CheckCircle className="w-12 h-12 text-emerald-400 mx-auto mb-3" />
                      <p className="text-muted-foreground">No pending approvals</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {pendingFounders.map((founder) => (
                        <div key={founder.id} className="wm-card p-4 rounded-lg flex items-center justify-between" data-testid="pending-founder">
                          <div>
                            <h3 className="font-semibold text-foreground">{founder.name}</h3>
                            <p className="text-sm text-muted-foreground">{founder.email}</p>
                            <p className="text-xs text-muted-foreground mt-1">
                              Joined: {new Date(founder.created_at).toLocaleDateString()} | Referral: {founder.referral_code}
                            </p>
                          </div>
                          <div className="flex gap-2">
                            <Button
                              size="sm"
                              className="bg-emerald-600 text-white hover:bg-emerald-700"
                              onClick={async () => {
                                try {
                                  await axios.post(`${API_URL}/api/admin/founders/${founder.id}/approve`, {}, { headers: getAuthHeader() });
                                  toast.success(`${founder.name} approved as Founder`);
                                  fetchAllData();
                                } catch (e) {
                                  toast.error('Failed to approve');
                                }
                              }}
                              data-testid="approve-founder-btn"
                            >
                              Approve
                            </Button>
                            <Button
                              size="sm"
                              variant="outline"
                              className="border-red-500 text-red-400 hover:bg-red-500/10"
                              onClick={async () => {
                                if (!confirm(`Reject ${founder.name}? They'll be downgraded to Growth.`)) return;
                                try {
                                  await axios.post(`${API_URL}/api/admin/founders/${founder.id}/reject`, {}, { headers: getAuthHeader() });
                                  toast.success('Founder rejected');
                                  fetchAllData();
                                } catch (e) {
                                  toast.error('Failed to reject');
                                }
                              }}
                              data-testid="reject-founder-btn"
                            >
                              Reject
                            </Button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
    </div>
  );
}
